import { PayloadAction, createSlice } from '@reduxjs/toolkit';

export interface PaginationState {
  page: number;
  limit: number;
}

const initialState: PaginationState = {
  page: 0,
  limit: 10,
};

const paginationSlice = createSlice({
  name: `pagination`,
  initialState,
  reducers: {
    setPaginationState: (state, action: PayloadAction<PaginationState>) => {
      (state.page = action.payload.page), (state.limit = action.payload.limit);
    },
  },
});

export const { setPaginationState } = paginationSlice.actions;
export default paginationSlice.reducer;
